import { render, staticRenderFns } from "./ConfiguracaoIA.vue?vue&type=template&id=9e58f254&scoped=true"
import script from "./ConfiguracaoIA.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoIA.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoIA.vue?vue&type=style&index=0&id=9e58f254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e58f254",
  null
  
)

export default component.exports